import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { useInvalidateQuery as useInvalidateNotificationQuery } from "@faire/web-api--source/api/retailer/notifications/get-hooks";
import { useState, useEffect } from "react";
export var useNotificationRealTimeUpdate = function() {
    var notificationUpdateState = useUserStore([
        "notificationUpdateState"
    ]).notificationUpdateState;
    var _ref = notificationUpdateState !== null && notificationUpdateState !== void 0 ? notificationUpdateState : {}, baseLatestStatusUpdate = _ref.latestStatusUpdate, baseUnviewedActiveNotificationCount = _ref.unviewedActiveNotificationCount;
    var _useState = _sliced_to_array(useState(baseLatestStatusUpdate), 2), latestStatusUpdate = _useState[0], setLatestStatusUpdate = _useState[1];
    var _useState1 = _sliced_to_array(useState(baseUnviewedActiveNotificationCount), 2), unviewedActiveNotificationCount = _useState1[0], setUnviewedActiveNotificationCount = _useState1[1];
    var invalidateNotificationQuery = useInvalidateNotificationQuery();
    useEffect(function() {
        // Making sure we update when the count or type of notification changes
        // This is controlled by SEND_WEB_SOCKET_MESSAGE_FOR_NOTIFICATIONS_HACK_WEEK_XP_241218
        // on BE
        if (latestStatusUpdate !== baseLatestStatusUpdate || unviewedActiveNotificationCount !== baseUnviewedActiveNotificationCount) {
            invalidateNotificationQuery();
            setLatestStatusUpdate(baseLatestStatusUpdate);
            setUnviewedActiveNotificationCount(baseUnviewedActiveNotificationCount);
        }
    }, [
        baseLatestStatusUpdate,
        baseUnviewedActiveNotificationCount,
        invalidateNotificationQuery,
        latestStatusUpdate,
        unviewedActiveNotificationCount
    ]);
};
